import styled from 'styled-components';

export const Container = styled.div``;

export const Step = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  gap: 4px;
  background-color: #f2f2f2;
`;

export const StepArrow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0;
`;

export const Description = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: #333333;
`;
